import { Table, Tooltip } from "antd";
import { useContext, useEffect, useState } from "react";
import { RiFileExcel2Line, RiDeleteBinLine } from "react-icons/ri";
import { AiOutlineSafetyCertificate } from "react-icons/ai";
import { SlReload } from "react-icons/sl";

import { LuUpload, LuPlus, LuShieldClose } from "react-icons/lu";

import { FiEdit } from "react-icons/fi";
import { ExportToExcel } from "../../../utils/exportExcel";

import CreateBusiness from "./components/CreateBusiness";
import UploadSign from "./components/UploadSign";
import { useQuery } from "@tanstack/react-query";
import { handleExportUsers } from "../../../api/users";
import Something from "../../../components/shared/Something";
import ResetPassword from "./components/ResetPassword";
import UploadCustomers from "./components/UploadCustomers";
import { handleFetchBusinesses } from "../../../api/businesses";
import CreateBrand from "./components/CreateBrand";
import UpdateBusiness from "./components/UpdateBusiness";
import BUnits from "./BUnits";
import { AuthContext } from "../../../contexts/AuthContext";
import Error from "../../../components/shared/Error";

export default function Businesses() {
  const { auth } = useContext(AuthContext);
  const [selected, setSelected] = useState<any>({});
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [createBrandModal, setCreateBrandModal] = useState<boolean>(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [resetModal, setResetModal] = useState<boolean>(false);
  const [signModal, setSignModal] = useState<boolean>(false);
  const [uploadModal, setUploadModal] = useState<boolean>(false);
  const [isExporting, setExporting] = useState<boolean>(false);
  const access = [4, 5, 9];

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });

  const {
    data: businesses,
    refetch,
    isLoading,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["businesses", pagination.page, pagination.limit],
    queryFn: () =>
      handleFetchBusinesses({ page: pagination.page, limit: pagination.limit }),
  });

  const handlePageChange = (e: any) => {
    setPagination((prev: any) => ({
      ...prev,
      page: e.current,
      limit: e.pageSize,
    }));
  };
  const handleRefetch = () => {
    refetch();
  };

  const columns = [
    {
      title: "S/N",
      width: 40,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">
          {pagination?.page * pagination?.limit - pagination?.limit + index + 1}
        </span>
      ),
    },
    {
      title: "LOGO",
      width: 100,
      render: (record: any) => {
        return (
          <div className="text-gray-700">
            {record?.logo && (
              <img src={record?.logo} width={80} height={40} alt="" />
            )}
          </div>
        );
      },
    },
    {
      title: "NAME",
      width: 200,
      render: (record: any) => (
        <div className="">
          <span className="text-gray-700">{record?.name || "-"}</span>
          <div className="flex justify-between">
            <div className="">Brands</div>
            <button
              className="border px-2"
              onClick={() => {
                setSelected(record);
                setCreateBrandModal(true);
              }}
            >
              +
            </button>
          </div>
        </div>
      ),
    },
    {
      title: "No.",
      width: 40,
      render: (record: any) => (
        <div className="">
          <span className="text-gray-700">{record?.companyNo || "-"}</span>
        </div>
      ),
    },

    {
      title: "ADDRESS LINE 1",
      width: 110,
      render: (record: any) => (
        <span className="text-gray-700">{record?.addressLine1 || "-"}</span>
      ),
    },
    {
      title: "ADDRESS LINE 2",
      width: 110,
      render: (record: any) => (
        <span className="text-gray-700">{record?.addressLine2 || "-"}</span>
      ),
    },
    {
      title: "ADDRESS LINE 3",
      width: 110,
      render: (record: any) => (
        <span className="text-gray-700">{record?.addressLine3 || "-"}</span>
      ),
    },
    {
      title: "ADDRESS LINE 4",
      width: 110,
      render: (record: any) => (
        <span className="text-gray-700">{record?.addressLine4 || "-"}</span>
      ),
    },
    {
      title: "ADDRESS LINE 5",
      width: 110,
      render: (record: any) => (
        <span className="text-gray-700">{record?.addressLine5 || "-"}</span>
      ),
    },
    {
      title: "CUSTOMERS",
      width: 110,
      render: (record: any) => (
        <div className="">
          <button
            onClick={() => {
              setSelected(record);
              setUploadModal(true);
            }}
            className="flex mx-2 justify-center items-center border px-4 h-8   hover:bg-gray-100"
          >
            <LuUpload /> <span className="mx-2">Upload</span>
          </button>
        </div>
      ),
    },
    {
      title: "ACTIVE",
      width: 60,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.isActive ? (
            <div className="text-green-600 flex items-center">
              <div className="flex items-center">
                <AiOutlineSafetyCertificate size={18} />{" "}
                <span className="mx-1">YES</span>
              </div>
            </div>
          ) : (
            <div className="text-red-600 flex items-center">
              {" "}
              <LuShieldClose size={18} /> <span className="mx-1">NO</span>
            </div>
          )}
        </span>
      ),
    },
    {
      title: "ACTION",
      width: 100,
      render: (record: any) => (
        <div className="flex justify-end">
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setUpdateModal(true);
            }}
            className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-yellow-100 hover:bg-yellow-200"
          >
            <FiEdit />
          </button>

          <button
            onClick={() => {
              setSelected({
                ...record,
              });
            }}
            className="flex justify-center items-center ml-1 text-gray-700 border rounded-md p-2 bg-red-100 hover:bg-red-200 cursor-not-allowed"
          >
            <RiDeleteBinLine color="red" />
          </button>
        </div>
      ),
    },
  ];

  const exportUsers = async () => {
    setExporting(true);
    const users = await handleExportUsers();
    await ExportToExcel(
      users?.map((item: any) => {
        return {
          EMP_ID: item?.empId || "-",
          EMAIL: item?.email || "-",
          FULLNAME: item?.name || "-",
          BUSINESS_UNIT: item?.businessUnit || "-",
          LEGAL_ENTITY: item?.legalEntity || "-",
          MOBILE: item?.mobile || "-",
        };
      }),
      "Businesses.xlsx"
    );
    setExporting(false);
  };

  useEffect(() => {
    setPagination({ ...pagination, total: businesses?.total });
  }, [businesses]);

  if (!access.includes(auth?.accessLevel)) {
    return <Error error="You are not authorized to access this page" />;
  }
  return (
    <div className="bg-gray-100">
      <div className="bg-white m-1">
        <div className="flex flex-col sm:flex-row justify-between border-b p-2">
          <div className="">
            <div className="font-bold">Businesses</div>
            <div className="text-gray-600">Manage Business Details</div>
          </div>

          <div className="flex">
            <Tooltip title="Export To Excel">
              <button
                className="flex mx-2 justify-center items-center border px-4 h-8  hover:bg-gray-100"
                onClick={() => exportUsers()}
              >
                {isExporting ? <SlReload /> : <RiFileExcel2Line size={20} />}
              </button>
            </Tooltip>

            <button
              onClick={() => setCreateModal(true)}
              className="flex mx-2 justify-center items-center border px-4 h-8  hover:bg-gray-100"
            >
              <LuPlus size={18} /> <span className="mx-2">New</span>
            </button>
          </div>
        </div>
        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="">
            <Table
              size="small"
              dataSource={businesses?.records}
              columns={columns}
              scroll={{ y: 660, x: 0 }}
              rowKey="id"
              style={{ fontSize: "12px" }}
              bordered
              pagination={{
                current: pagination?.page,
                pageSize: pagination?.limit,
                total: pagination?.total,
              }}
              onChange={(e: any) => handlePageChange(e)}
              loading={isLoading}
            />
            <BUnits />
          </div>
        )}
      </div>

      <CreateBusiness
        isVisible={createModal}
        setVisible={setCreateModal}
        refetch={handleRefetch}
      />

      <CreateBrand
        isVisible={createBrandModal}
        setVisible={setCreateBrandModal}
        business={selected}
        refetch={handleRefetch}
      />

      <UpdateBusiness
        isVisible={updateModal}
        setVisible={setUpdateModal}
        refetch={refetch}
        selected={selected}
      />

      <UploadSign
        isVisible={signModal}
        setVisible={setSignModal}
        selected={selected}
        refetch={refetch}
      />

      <UploadCustomers
        isVisible={uploadModal}
        setVisible={setUploadModal}
        selected={selected}
        refetch={refetch}
      />

      <ResetPassword
        isVisible={resetModal}
        setVisible={setResetModal}
        refetch={refetch}
        selected={selected}
      />
    </div>
  );
}
